<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="login-intro" fxFlex>

        <div class="logo" [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">
            <img src="assets/images/logos/icono.jpg">
        </div>

        <div class="title" *ngIf="idProveedor && idCliente" [@animate]="{value:'*',params:{delay:'600ms',y:'25px'}}">
            {{ 'AUTHENTICATION.WELCOME' | translate }}
        </div>

        <div class="title" *ngIf="!idProveedor || !idCliente" [@animate]="{value:'*',params:{delay:'600ms',y:'25px'}}">
            {{ 'AUTHENTICATION.THANKS' | translate }}
        </div>

        <div class="title" *ngIf="!idProveedor || !idCliente" [@animate]="{value:'*',params:{delay:'2000ms',y:'25px'}}">
            <br /><br />
            {{ 'AUTHENTICATION.SEE_YOU_SOON' | translate }}
        </div>


    </div>

</div>